__turbopack_context__.v({
  "chartWrap": "Dmob3G_chartWrap",
  "container": "Dmob3G_container",
  "content": "Dmob3G_content",
  "variant--curve": "Dmob3G_variant--curve",
  "variant--timeline": "Dmob3G_variant--timeline",
  "variant--type": "Dmob3G_variant--type",
});
